<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>{{ info.authorize ? '' : '停用' }}授权店铺</BjDivider>
    <el-col :span="24">
      <el-form-item label="店铺">{{ info.onlineName }}</el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="渠道">{{ info.channelWarehouseName }}</el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="平台账号" prop="name">
        <BjInput
          v-model="form.name"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="Appkey" prop="Appkey">
        <BjInput
          v-model="form.Appkey"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        /> </el-form-item
    ></el-col>
    <el-col :span="24">
      <el-form-item label="Appsecret" prop="Appsecret">
        <BjInput
          v-model="form.Appsecret"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        /> </el-form-item
    ></el-col>
    <el-col :span="24">
      <el-form-item label="SessionKey" prop="SessionKey">
        <BjInput
          v-model="form.SessionKey"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        /> </el-form-item
    ></el-col>
  </BjDrawerForm>
</template>
<script>
// import { channelApi } from '@/api';

const getDefaultForm = () => {
  return {
    name: '',
    Appkey: '',
    Appsecret: '',
    SessionKey: '',
  };
};

export default {
  data() {
    return {
      info: {},
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        Appkey: [{ required: true, message: '请输入 Appkey', trigger: 'blur' }],
        Appsecret: [{ required: true, message: '请输入 Appsecret', trigger: 'blur' }],
        SessionKey: [{ required: true, message: '请输入 SessionKey', trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.info = info;
      this.$refs.BjDrawerForm.show();
      this.form = Object.assign(getDefaultForm());
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      this.saveApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },

    saveApi(API_DATA) {
      this.$message.success(this.$t('toast.operationSuccessText'));
      setTimeout(() => {
        this.$refs.BjDrawerForm.hide();
        this.reFresh();
      }, 500);
      // channelApi.saveOnlineShop(API_DATA).then(res => {
      //   if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
      //     this.$message.success(this.$t('toast.operationSuccessText'));
      //     setTimeout(() => {
      //       this.$refs.BjDrawerForm.hide();
      //       this.reFresh();
      //     }, 500);
      //   }
      // });
    },
  },
};
</script>
<style scoped></style>
